<template>
	<div>
		<input type="hidden" name="provider" :value="provider.id" v-if="provider.label"/>
		<div v-else-if="noProvider">
			<div class="help-block">
				<p><strong>We are not currently providing services in your state. Please check back with us again soon.</strong></p>
			</div>
		</div>
		
		<!-- Restricted State Modal -->
		<div class="modal__wrapper" v-if="showRestrictedStateModal">
			<div class="modal__screen" @click.prevent="closeRestrictedStateModal"></div>
			<div class="modal">
				<div class="modal__header">
					<a href="#" class="modal__close" @click.prevent="closeRestrictedStateModal">
						<i class="fa fa-times"></i>
					</a>
				</div>
				<div class="modal__body">
					<p><strong>We do not provide services in your state at this time, please contact support@boldrx.com</strong></p>
					<button class="button button-primary--small" @click.prevent="closeRestrictedStateModal">OK</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    selectId: {
      default: 'state',
    },
  },
  data: function() {
    return {
      provider: {
        id: 0,
      },
      noProvider: false,
      showRestrictedStateModal: false,
      restrictedStates: ['AK', 'AR', 'DE', 'ID', 'IN', 'DC', 'LA', 'ME', 'NH', 'NM', 'WV','HI', 'RI', 'SC', 'SD', 'VT'],
      selectedState: null,
    };
  },
  mounted() {
    this.checkStateField();
    const selectElement = document.getElementById(this.selectId);
    if (selectElement) {
      selectElement.addEventListener('change', () => {
        this.checkStateField();
      });
    }
    
    // Prevent form submission when restricted state is selected
    const form = selectElement ? selectElement.closest('form') : null;
    if (form) {
      form.addEventListener('submit', (e) => {
        if (this.isRestrictedState(this.selectedState)) {
          e.preventDefault();
          this.showRestrictedStateModal = true;
          return false;
        }
      });
    }
  },
  methods: {
    checkStateField() {
      var select = document.getElementById(this.selectId);
      if (!select) return;
      
      var state = select.options[select.selectedIndex].value;
      this.selectedState = state;
      
      if (state) {
        // Check if state is restricted first
        if (this.isRestrictedState(state)) {
          this.showRestrictedStateModal = true;
          this.provider = {};
          this.noProvider = false;
          return;
        }
        
        // If not restricted, proceed with provider check
        this.retrieveDermForState(state);
      } else {
        this.provider = {};
        this.noProvider = false;
      }
    },
    isRestrictedState(state) {
      return this.restrictedStates.includes(state);
    },
    retrieveDermForState(state) {
      axios
        .get('/api/v1/providers?state=' + state + '&checkout=1')
        .then((response) => {
          if (response.data.data.length) {
            this.provider = response.data.data[0];
            this.noProvider = false;
          } else {
            this.provider = {};
            this.noProvider = true;
          }
        })
        .catch((e) => console.log(e));
    },
    closeRestrictedStateModal() {
      this.showRestrictedStateModal = false;
      // Reset state dropdown to empty or previous valid state
      var select = document.getElementById(this.selectId);
      if (select) {
        select.value = '';
        this.selectedState = null;
        this.provider = {};
        this.noProvider = false;
      }
    },
    getAvatar() {
      if (this.provider && this.provider.avatar) {
        return this.provider.avatar;
      }
      return '/images/default-avatar.png';
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/StateOrderSelection.vue